import { api } from './client.js';

export const resume = {
  get:       ()     => api.get('/resume'),
  put:       (body) => api.put('/resume', body),
  calculate: (body) => api.post('/resume/calculate', body),
};
